module.exports = __webpack_public_path__ + "static/img/download-android.a9a2661.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download-android.png
// module id = DJ1a
// module chunks = 114